import { DefaultSpacesSettings } from './DefaultSpacesSettings'
import { GeneralSettings } from './GeneralSettings'
import { LandingPageSettings } from './LandingPageSettings'
import { PermissionsSettings } from './PermissionsSettings'
import { WhiteLabelSettings } from './WhiteLabelSettings'

export const Settings = () => {
  return (
    <div className="flex flex-col space-y-5 max-w-3xl">
      <GeneralSettings />
      {false && <LandingPageSettings />}
      <DefaultSpacesSettings />
      <PermissionsSettings />
      <WhiteLabelSettings />
    </div>
  )
}
